var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.underlay ? 'map' : 'mb-3 card shadow-sm',staticStyle:{"height":"350px"},attrs:{"id":_vm.mapId}})])}
var staticRenderFns = []

export { render, staticRenderFns }